import React from 'react';
import styles from './ServiceNeeded.module.scss';
import { IServiceGroups, IServiceItem } from './utils';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

interface ServiceNeededTableProps {
    data: IServiceGroups;
}

const ServiceNeededTable: React.FC<ServiceNeededTableProps> = ({ data }) => {

    const renderGroup = (items: IServiceItem[], title: string, variant: 'expired' | 'warning') => {
        if (!items || items.length === 0) return null;

        return (
            <React.Fragment key={title}>
                <tr className={classNames(styles.groupHeaderRow, styles[`group_${variant}`])}>
                    <td colSpan={5} className={styles.groupHeaderCell}>
                        {title} ({items.length})
                    </td>
                </tr>
                {items.map((item, index) => (
                    <tr key={`${item.deviceId}-${item.itemName}-${index}`}>
                        <td><Link to={`/device/${item.deviceId}`}>{item.vehicleName}</Link></td>
                        <td>{item.itemName}</td>
                        <td>{item.lastServiceDate}</td>
                        <td>{item.dueDate}</td>
                        <td className={classNames(styles.daysLeft, styles[`text_${variant}`])}>
                            {item.daysLeft < 0 ? 'Past Due' : item.daysLeft}
                        </td>
                    </tr>
                ))}
            </React.Fragment>
        );
    };

    return (
        <div className={styles.tableWrapper}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Vehicle Name</th>
                        <th>Service Type</th>
                        <th>Last Service</th>
                        <th>Due Date</th>
                        <th>Days Left</th>
                    </tr>
                </thead>
                <tbody>
                    {renderGroup(data.expired, 'Service Overdue', 'expired')}
                    {renderGroup(data.days30, 'Service Due in 30 Days', 'warning')}
                </tbody>
            </table>
        </div>
    );
};

export default ServiceNeededTable;